import React, { Component } from 'react';
import { Form, Input, Button, Popconfirm } from 'antd';
import { withTranslation } from 'react-i18next';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {t,filterChange,search,add,del,exp}=this.props
    return (
      <Form layout="inline">
        <Form.Item label={t('Keyword')}>
          <Input allowClear onChange={(e)=>{filterChange('key',e.target.value)}}></Input>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={search}>{t('Search')}</Button>
        </Form.Item>
        <Form.Item>
          <Button onClick={add}>{t('Add')}</Button>
        </Form.Item>
        <Form.Item>
          <Popconfirm title={t("Delete the selected customer service contact numbers?")} okType="danger"  onConfirm={del}>
            <Button type="danger">{t('Delete')}</Button>
          </Popconfirm>
        </Form.Item>
        <Form.Item>
          <Button onClick={exp}>{t('Export All')}</Button>
        </Form.Item>
      </Form>
    )
  }
}

export default withTranslation()(Filter);